export default __webpack_public_path__ + "static/media/edit-pencil.32ac978b.svg";